module.exports = __webpack_public_path__ + "img/authenticate1.30f290c0.png";